import { isUuid } from '@newfront-insurance/admin-ui';

export interface AccountBootstrapOptions {
  activeAccountUuid?: string;
  initialAccountUuid?: string;
  queryAccountUuid?: string;
}

// Drops non-UUID strings so a stray URL segment like /accounts/policies cannot
// reach downstream GraphQL queries that validate UUID input.
function pickValidUuid(value: string | undefined): string | undefined {
  return value && isUuid(value) ? value : undefined;
}

export function resolvePageAccountUuid({
  initialAccountUuid,
  queryAccountUuid,
}: Pick<AccountBootstrapOptions, 'initialAccountUuid' | 'queryAccountUuid'>): string | undefined {
  return pickValidUuid(initialAccountUuid) ?? pickValidUuid(queryAccountUuid);
}

export function resolveEffectiveAccountUuid({
  activeAccountUuid,
  initialAccountUuid,
  queryAccountUuid,
}: AccountBootstrapOptions): string | undefined {
  return pickValidUuid(activeAccountUuid) ?? resolvePageAccountUuid({ initialAccountUuid, queryAccountUuid });
}
